import { render } from "./Shapes.vue?vue&type=template&id=2ac06da4"
import script from "./Shapes.vue?vue&type=script&lang=js"
export * from "./Shapes.vue?vue&type=script&lang=js"

import "./Shapes.vue?vue&type=style&index=0&id=2ac06da4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__